<template>
  <main v-if="!isLoadingView" class="l-main p-config-payment">
    <TitleMain icon="config">
      <span class="title">ユーザー情報・各種設定</span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <div class="l-block l-block--center">
        <TabConfig active="payment" />
        <div class="l-block__content">
          <div class="l-block__header">
            <TitleSub level="h3">
              <span class="title">請求書</span>
            </TitleSub>
          </div>
          <ListInvoices />

          <div class="l-block__header">
            <TitleSub level="h3" class="l-mt-10">
              クレジットカード情報
            </TitleSub>
          </div>
          <Loading v-if="isLoading" variant="inline" transparent />
          <Alert v-else-if="errorResponse">
            {{ errorResponse }}
          </Alert>
          <template v-else>
            <table class="c-table">
              <thead>
                <tr>
                  <th>クレジットカード番号</th>
                  <th>MM/YY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="c-text--center">{{ cardNumber }}</td>
                  <td class="c-text--center">{{ expirationDate }}</td>
                </tr>
              </tbody>
            </table>
            <div class="l-block__header">
              <TitleSub level="h4" class="l-mt-10">
                クレジットカード情報変更
              </TitleSub>
            </div>
            <FormRegisterCard isEdit @submit="submitCard" />
            <Note class="l-mt-10">
              <p>
                請求やお支払に関するお問い合わせは、カスタマーサポート(<a
                  :href="'mailto:' + $constants.customerSupportEmail"
                  >{{ $constants.customerSupportEmail }}</a
                >)までご連絡いただきますようお願いいたします。
              </p>
            </Note>
          </template>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import FormRegisterCard from '@/components/config/FormRegisterCard';
import ListInvoices from '@/components/config/ListInvoices';
import Loading from '@/components/Loading';
import Note from '@/components/Note';
import TabConfig from '@/components/config/TabConfig';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';
import apiUsers from '@/api/users';

export default {
  props: ['project'],
  components: {
    Alert,
    Breadcrumb,
    ButtonToProjects,
    FormRegisterCard,
    ListInvoices,
    Loading,
    Note,
    TabConfig,
    TitleMain,
    TitleSub
  },
  data() {
    return {
      data: {
        card: {
          brand: '',
          expirationMonth: '',
          expirationYear: '',
          last4digits: ''
        }
      },
      errorResponse: '',
      isLoading: true
    };
  },
  computed: {
    cardNumber() {
      let number = '-';
      if (this.data.card.last4digits) {
        number = `XXXX XXXX XXXX ${this.data.card.last4digits}`;
      }
      return number;
    },
    expirationDate() {
      let date = '-';
      if (this.data.card.expirationYear && this.data.card.expirationMonth) {
        date = this.$options.filters.dateText(
          this.data.card.expirationYear + '-' + this.data.card.expirationMonth,
          'MM/YY'
        );
      }
      return date;
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    isDelegate() {
      return this.organization.isDelegate;
    },
    isLoadingView() {
      return this.$store.state.view.isLoading;
    }
  },
  created() {
    this.getMe();
  },
  methods: {
    getMe() {
      // 代表者かどうか確認できるまでローダーを表示する
      this.$store.dispatch('view/setLoading', true);

      this.$store.dispatch('user/getMe').finally(() => {
        if (this.isDelegate) {
          this.$store.dispatch('view/setLoading', false);
          this.getCard();
        } else {
          this.$router.push({ name: 'projects' });
        }
      });
    },
    getCard() {
      return apiUsers.me.creditCard
        .get(this.auth.idToken)
        .then(response => {
          this.data.card = response.data;
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitCard() {
      this.getCard();
    }
  }
};
</script>
